import { JobStep } from "projen/lib/github/workflows-model";
import { VERSION } from "../versions";

/**
 * Steps that put Node on the runner.
 *
 * Occasionally fails on GitHub-internal issues, hence the short timeout.
 */
export const renderSetupNode = (): Array<JobStep> => {
  return [
    {
      name: "Setup Node",
      uses: `actions/setup-node@${VERSION.SETUP_NODE_ACTION_VERSION}`,
      with: {
        ["node-version"]: VERSION.NODE_WORKFLOWS,
      },
      timeoutMinutes: 1,
    },
  ];
};

/**
 * Steps that put pnpm on the runner, pinned to the project's version.
 */
export const renderSetupPnpm = (pnpmVersion: string): Array<JobStep> => {
  return [
    {
      name: "Setup PNPM",
      uses: `pnpm/action-setup@${VERSION.PNPM_ACTION_SETUP_VERSION}`,
      with: {
        version: pnpmVersion,
      },
    },
  ];
};
